import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function HowItWorks() {
  const timeline = [{
    days: 'Día 1–3',
    title: 'Radiografía Financiera Real',
    desc: 'Sin culpas. Sin juicios. Solo claridad.',
    color: 'bg-pink-100 text-pink-700 border-pink-200'
  }, {
    days: 'Día 4–7',
    title: 'Reestructuración Inteligente',
    desc: 'Redistribuimos tu dinero sin extremismos.',
    color: 'bg-purple-100 text-purple-700 border-purple-200'
  }, {
    days: 'Día 8–12',
    title: 'Blindaje Antiansiedad',
    desc: 'Creamos tu mini-fondo de seguridad.',
    color: 'bg-amber-100 text-amber-700 border-amber-200'
  }, {
    days: 'Día 13–15',
    title: 'Consolidación',
    desc: 'Terminas la quincena con control y aire financiero.',
    color: 'bg-green-100 text-green-700 border-green-200'
  }];
  const checklist = ['Método paso a paso por 15 días', 'Sistema quincenal simple y práctico', 'Plantillas fáciles de usar', 'Guía para crear un mini-fondo de emergencia', 'Reprogramación mental financiera', 'Estructura replicable cada quincena'];
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-65">
      <div className="container mx-auto px-4" data-id="element-66">
        <div className="max-w-4xl mx-auto" data-id="element-67">
          <div className="text-center mb-16" data-id="element-68">
            <h2 className="text-3xl md:text-5xl font-bold text-purple-900 mb-6 font-serif" data-id="element-69">
              Cómo Funciona el Reset de 15 Días
            </h2>
          </div>

          {/* Timeline */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-70">
            {timeline.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-71">
                <div className={`inline-block px-4 py-1 rounded-full text-sm font-bold mb-4 w-max ${item.color}`} data-id="element-72">
                  {item.days}
                </div>
                <h4 className="text-xl font-bold text-purple-900 mb-2" data-id="element-73">
                  {item.title}
                </h4>
                <p className="text-gray-600" data-id="element-74">{item.desc}</p>
              </motion.div>)}
          </div>

          <div className="text-center mb-20" data-id="element-75">
            <p className="text-xl text-gray-500 italic mb-2" data-id="element-76">
              No es un presupuesto rígido.
            </p>
            <p className="text-2xl font-bold text-purple-900" data-id="element-77">
              Es un sistema de respiración financiera que puedes repetir cada
              quincena.
            </p>
          </div>

          {/* What You Get */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border-t-4 border-purple-500" data-id="element-78">
            <h3 className="text-3xl font-bold text-center text-purple-900 mb-10 font-serif" data-id="element-79">
              Lo Que Recibes
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-80">
              {checklist.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-81">
                  <CheckCircle2 className="w-6 h-6 text-pink-500 flex-shrink-0 mt-0.5" data-id="element-82" />
                  <span className="text-lg text-gray-700 font-medium" data-id="element-83">
                    {item}
                  </span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}